import React, { forwardRef, useEffect, useState, } from 'react';
import dayjs from 'dayjs';
import { SelectDrawer as CnSelectDrawer } from '@/components/cn-select/select-drawer';
import { CnEmbedPicker } from './embed-picker';
import isFunction from 'lodash/isFunction';
import { isValidDate, toDate } from '@/utils/date';
const TimePicker = (props, ref) => {
    const { prefix = 'cn-ui-m-', value: valueProp, defaultValue, size: sizeProp, align: alignProp, iconType, placeholder, format, hasClear, disabled, outputFormat, readOnly, onChange = () => { }, onClear = () => { }, onCancel = () => { }, className, zIndex, ...others } = props;
    const [value, setValue] = useState(toDate(valueProp || defaultValue));
    const [pickerValue, setPickerValue] = useState(value || new Date());
    const [visible, setVisible] = useState(false);
    const align = alignProp || 'left';
    const size = sizeProp || 'medium';
    const isControlled = 'value' in props;
    const handleOk = () => {
        const newValue = pickerValue;
        if (onChange) {
            onChange(outputFormat
                ? dayjs(newValue).format(outputFormat)
                : newValue.getTime(), dayjs(newValue).format('HH:mm:ss'));
        }
        if (!isControlled) {
            setValue(newValue);
        }
    };
    useEffect(() => {
        if ('value' in props) {
            const newValue = toDate(valueProp || defaultValue);
            if (!isValidDate(newValue)) {
                setValue(undefined);
                return;
            }
            else if (newValue === value) {
                return;
            }
            setValue(newValue);
            setPickerValue(newValue);
        }
    }, [valueProp]);
    const handleCancel = (reason) => {
        setPickerValue(value || new Date());
        if (isFunction(onCancel)) {
            onCancel(reason);
        }
    };
    const handleChange = (d) => setPickerValue(d);
    const handleClear = () => {
        if (!isControlled) {
            setPickerValue(new Date());
            setValue(undefined);
        }
        if (onClear) {
            onClear();
        }
        if (onChange) {
            onChange(undefined, '');
        }
    };
    return (React.createElement(CnSelectDrawer, { disableScroll: true, hasClear: hasClear, content: value ? dayjs(value).format(format || 'HH:mm') : '', align: align, size: size, iconType: iconType, placeholder: placeholder, disabled: disabled, readOnly: readOnly, className: className, insideForm: props.insideForm, onVisibleChange: setVisible, zIndex: zIndex, onOk: handleOk, onCancel: handleCancel, onClear: handleClear, ref: ref },
        React.createElement(CnEmbedPicker, { ...others, prefix: prefix, visible: visible, value: pickerValue, onCancel: handleCancel, format: format || 'HH:mm', onChange: (v = new Date()) => handleChange(v) })));
};
TimePicker.displayName = 'CnTimePicker';
const CnTimePicker = forwardRef(TimePicker);
CnTimePicker.displayName = 'CnTimePickerPro';
export { CnTimePicker };
